/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Status of a subscription step.
 * 
 * - pending: Step is not yet accessible (previous steps not completed)
 * - current: Active step where the user should currently work
 * - completed: Step has been successfully completed
 * 
 * @export
 */
export const StepStatus = {
    Pending: 'pending',
    Current: 'current',
    Completed: 'completed'
} as const;
export type StepStatus = typeof StepStatus[keyof typeof StepStatus];


export function instanceOfStepStatus(value: any): boolean {
    for (const key in StepStatus) {
        if (Object.prototype.hasOwnProperty.call(StepStatus, key)) {
            if (StepStatus[key as keyof typeof StepStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StepStatusFromJSON(json: any): StepStatus {
    return StepStatusFromJSONTyped(json, false);
}

export function StepStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): StepStatus {
    return json as StepStatus;
}

export function StepStatusToJSON(value?: StepStatus | null): any {
    return value as any;
}

export function StepStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): StepStatus {
    return value as StepStatus;
}

